export default {
    listagem: {
        titulo_pagina: 'Broadcast List',
        table: {
            transmissao: "Broadcast",
            resposta: "Response",
            mensagem: "Message",
            criadoem: "Created at",
            empty: "No Stream Found",
            visualizar: "View"
        }
    },
    show: {
        title: 'View Broadcast'
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Broadcast',
            editar: 'Edit Broadcast'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'State Name'
            },
            botao_salvar : 'Transmit Result'
        },
        create: {
            success: "Result Transmitted Successfully!",
            error: "Error Transmitting Result!"
        },
        update: {
            success: "Result Successfully Edited!",
            error: "Error Editing Result!"
        }
    },
    transmissao: {
        titulo_pagina: 'Report Exam to Interoperability',
        importacao_massa: 'Bulk Import',
        funcionalidade_contrucao: 'Functionality under Construction...',
        escolha_arquivo_importacao: 'Choose a file to import',
        arraste_solte_arquivo: 'Or drag and drop a file here',
        selecionar: 'Select',
        separador: 'Separator',
        arquivo_importacao_valores: {
            tab: 'Tab',
            pipe: 'Pipe',
            espaco: 'Space',
            virgula: 'Comma',
            ponto: 'Dot'
        },
        quantidade_coluna: 'Number of Columns',
        importar: 'Import',
        campos: {
            cpf_label: 'CPF',
            cpf_descricao: 'Patient CPF',
            cns_label: 'CNS',
            cns_descricao: 'CNS of the Technical Manager',
            exame_label: 'Exam',
            resultado_label: 'Result',
            resultado_valores: {
                detectavel: 'Detectable',
                nao_detectavel: 'Undetectable',
                inconclusivo: 'Inconclusive',
            },
            amostra_biologica_label: 'Biological Sample',
            data_label: 'Date',
            data_descricao: 'Processing Date',
            uf_laboratorio_label: 'Laboratory State'
        },
        reporte_enviado: 'Report Sent! Check the list for Status',
        erro_reportar_exame: 'Error Reporting Exam'
    }
}
